import React from 'react';
import ReactGA from 'react-ga';
import imgUrl from '../../assets/gie-logo-bg-3.jpg';
import InformationsController from '../../controller/informations.controller';
import userInformations from '../../userInformation/user_informations';
import GIEServicesContainer from "../../components/GIEServicesContainer/GIEServicesContainer";
import CardHome from "../Home/CardHome";
import {DateUtil} from "../../util/date-util";
import TitleListScreen from "../../components/TitleListeScreen/TitleListScreen";
import enveloppeIcon from '../../assets/icon/envelope.svg';
import euroIcon from '../../assets/icon/circle-euro.svg';
import fileIcon from '../../assets/icon/file-lines.svg';
import vanIcon from '../../assets/icon/van.svg';
import chauffeEauIcon from '../../assets/icon/chauffe-eau.svg';
import GIESvgIcon from "../../components/GIEIcon/GIESvgIcon";

export default class MyInformations extends React.Component<any, any> {
  informationsController: InformationsController = new InformationsController();

  constructor(props: any) {
    super(props);
    this.state = {
      bankInformations: {},
      contract: {},
      user: {}
    }
  }

  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
    const noContract = userInformations.getNoContract();
    if (!noContract?.length) {
      window.location.href = "/admin/login"
    } else {
      this.getData()
    }
  }

  getData = () => {
    this.informationsController.getUserInformations().then((data: any) => {
      this.setState({bankInformations: data.bankInformations, contract: data.contract, user: data.user})
    }).catch(err => {
      console.log(err)
    })
  }

  redirect = (url) => {
    window.location.href = url
  }

  render() {
    const {contract, user, bankInformations} = this.state
    return (
      <div className="content">
        <GIEServicesContainer imgUrl={imgUrl} title={<TitleListScreen miniTitle="Mes informations"
                                                                      href="mes-informations"
                                                                      title="Les informations liées à votre compte"/>}>
          <div className="container-xl mb-5">
            <div className="row g-4">
              <div className="col-xs-12 col-lg-4">
                <CardHome firstTitle="VOTRE CONTRAT"
                          secondTitle={contract?.contractNo || " "}
                          icon={<GIESvgIcon big icon={fileIcon}/>}
                          notClickable
                          hideLink>
                  <div
                    className="fs-5">{contract?.startingDate ? "du " + DateUtil.convertDateInString(new Date(contract.startingDate)) : " "}</div>
                </CardHome>
              </div>
              <div className="col-xs-12 col-lg-4">
                <CardHome firstTitle="VOS COORDONNÉES"
                          icon={<GIESvgIcon big icon={enveloppeIcon}/>}
                          notClickable
                          hideLink>
                  <div className="text-start fs-5 px-4">
                    <div>
                      <span>Nom du titulaire :</span>
                      <span className="ms-1 fw-bold">{user?.name}</span>
                    </div>
                    <div>
                      <span>Adresse du site :</span>
                      <span className="ms-1 fw-bold">{user?.address}</span>
                    </div>
                    <div>
                      <span>Ville :</span>
                      <span className="ms-1 fw-bold">{user?.city}</span>
                    </div>
                    <div>
                      <span>N° de tél. :</span>
                      <span className="ms-1 fw-bold">{user?.phone_no}</span>
                    </div>
                    <div>
                      <span>Courriel :</span>
                      <span className="ms-1 fw-bold">{user?.email || user?.e_mail_service_order}</span>
                    </div>
                  </div>
                </CardHome>
              </div>
              <div className="col-xs-12 col-lg-4">
                <CardHome firstTitle="VOS COORDONNÉES BANCAIRES"
                          secondTitle=" "
                          icon={<GIESvgIcon big icon={euroIcon}/>}
                          notClickable
                          hideLink>
                  <div
                    className="fs-5">{bankInformations?.iban ?? "Vous n'avez pas de coordonnées bancaires renseignés."}</div>
                </CardHome>
              </div>
              <div className="col-xs-12 col-lg-4">
                <CardHome firstTitle="Modifier mon offre"
                          icon={<GIESvgIcon big icon={chauffeEauIcon}/>}
                          hideLink
                          url="/admin/changer-mon-offre"/>
              </div>
              <div className="col-xs-12 col-lg-4">
                <CardHome firstTitle="Mettre à jour mes coordonnées"
                          icon={<GIESvgIcon big icon={vanIcon}/>}
                          hideLink
                          url="/admin/coordonnees"/>
              </div>
              <div className="col-xs-12 col-lg-4">
                <CardHome firstTitle="Souscrire au prélèvement automatique"
                          icon={<GIESvgIcon big icon={euroIcon}/>}
                          hideLink
                          url="/admin/coordonnees-bancaires"/>
              </div>
            </div>
          </div>
        </GIEServicesContainer>
      </div>
    );
  }
}
